var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTfuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    style: {
      stroke: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tfc-linear-gradient",
    x1: -1074.44,
    y1: 5195.41,
    x2: -1074.44,
    y2: 5094.52,
    gradientTransform: "translate(-2828.07 -4347.56) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tfc-linear-gradient-2",
    x1: 21.09,
    y1: 9.04,
    x2: 69.55,
    y2: 77.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#tfc-linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tfc-linear-gradient-3",
    x1: 84.58,
    y1: 89.47,
    x2: 15.35,
    y2: 10.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#tfc-linear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, "\n      .tfc-cls-5{fill:#ff6200}\n      .tfc-cls-6{fill:#fff}\n    "))), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    style: {
      fill: "url(#tfc-linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 38.88,
    style: {
      fill: "url(#tfc-linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 35.16,
    style: {
      fill: "url(#tfc-linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tfc-cls-5",
    d: "M67.8,31.68c.51-1,.35-1.39,1.5-2.43a4.27,4.27,0,0,0,2-3.86s.21-3.58-4.38-9.4c.21,2.1.29,3.1-1.29,5.17-1.86,2.42-2,3.46-2,5.31A5.91,5.91,0,0,0,67.8,31.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "tfc-cls-5",
    d: "M68.06,34.36c-.63,3.65-.49,4.17-2.8,6-1.29,1.07-4.1,1.13-5.66.38-2.86-1.38-3.43-5.14-2.28-7.59,4.61-13.73-3.06-20.21-9.38-25.44.18,8.66.87,11.58-8.75,21-11.29,11.08-12,15.8-12,24.24,0,12,12.46,23.45,25.69,25.47,2.59-5.47,5.83-6.39,10.74-8.66,7.06-2.44,12.17-8.63,12.17-17.62C75.81,45.44,72.48,39.62,68.06,34.36Zm-3,20.31h-9.3V64H46.76v-9.3h-9.3V45.62H65.11Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "tfc-cls-6",
    d: "M66.31,29.44c.51-1,.35-1.38,1.5-2.42a4.28,4.28,0,0,0,2-3.86s.21-3.58-4.38-9.41c.21,2.11.29,3.1-1.29,5.17-1.86,2.43-2,3.46-2,5.31A5.9,5.9,0,0,0,66.31,29.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "tfc-cls-6",
    d: "M66.57,32.12c-.63,3.65-.49,4.17-2.8,6-1.29,1.07-4.1,1.13-5.66.37-2.86-1.38-3.43-5.14-2.28-7.59,4.61-13.73-3.06-20.21-9.38-25.44.18,8.66.87,11.59-8.75,21-11.29,11.08-12,15.8-12,24.25,0,12,12.46,23.45,25.69,25.46,2.59-5.46,5.83-6.39,10.74-8.66,7.06-2.43,12.17-8.63,12.17-17.62C74.32,43.2,71,37.39,66.57,32.12ZM63.62,52.44h-9.3v9.29h-9V52.44H36V43.38H63.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTfuel);
export default __webpack_public_path__ + "static/media/icon-tfuel.26133f396232181e81af2e9123b69d5a.svg";
export { ForwardRef as ReactComponent };